import { Controller } from "@hotwired/stimulus"

// handles multiple-filter dropdown from navbar button.

export default class extends Controller {
    static values = {
        ddPrefix: String // required; no default
    }

    toggle(event) {
        event.preventDefault()

        const trigger = event.currentTarget
        const targetId = trigger.dataset.ddTarget
        if (!targetId) return

        const parentLi = trigger.closest(`.${this.prefixed("filter-button-li")}`)
        const triggElt = parentLi?.querySelector(`a.${this.prefixed("filter-button")}`)

        const targetPanel = document.getElementById(targetId)
        if (!targetPanel) return

        const selectClass = this.prefixed("filter-select")
        const activeClass = this.prefixed("filter-select-background")


        parentLi.querySelectorAll(`.${selectClass}`).forEach(el => {
            if (el !== targetPanel) el.classList.add("hide");
        });

        parentLi.querySelectorAll(".dd-trigger").forEach(el => {
            if (el !== trigger) el.classList.remove(this.prefixed("filter-select-background"));
        });

        // Toggle active background and panel visibility
        trigger.classList.toggle(this.prefixed("filter-select-background"))
        targetPanel.classList.toggle("hide")

        const instance = M.Dropdown.getInstance(triggElt)
        if (instance) requestAnimationFrame(() => instance.recalculateDimensions())
    }

    prefixed(name) {
        return `${this.ddPrefixValue}-${name}`
    }
}
